import { CustomerCreateInput } from '@/__generated__/graphql';
import { Button, Checkbox, Stack, TextInput } from '@mantine/core';
import { hasLength, isNotEmpty, useForm } from '@mantine/form';

export type CustomerInput = Pick<
  CustomerCreateInput,
  'id' | 'pageId' | 'name' | 'email' | 'avatar' | 'active' | 'reason'
>;

interface CustomerFormProps {
  customer?: CustomerInput | null;
  onSubmit: (customer: CustomerInput) => void;
  loading?: boolean;
}

export const CustomerForm = ({ customer, onSubmit, loading }: CustomerFormProps) => {
  const form = useForm<CustomerInput>({
    initialValues: {
      id: customer?.id,
      pageId: customer?.pageId ?? '',
      name: customer?.name ?? '',
      email: customer?.email,
      avatar: customer?.avatar,
      active: customer?.active ?? true,
      reason: customer?.reason,
    },
    validate: {
      pageId: isNotEmpty('Enter page ID'),
      name: hasLength({ min: 3, max: 50 }, 'Name must be between 3 and 50 characters'),
    },
  });

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="xs">
        <TextInput
          {...form.getInputProps('pageId')}
          label="Page ID"
          description="Unique identifier of the page"
          required
          data-autofocus
        />
        <TextInput
          {...form.getInputProps('name')}
          label="Name"
          description="Name of the customer"
          required
        />
        <TextInput
          {...form.getInputProps('email')}
          label="Email"
          description="Email of the customer"
          type="email"
        />
        <TextInput
          {...form.getInputProps('avatar')}
          label="Avatar"
          description="Avatar of the customer"
          type="url"
        />
        <Checkbox
          label="Active"
          description="Is customer active"
          {...form.getInputProps('active', { type: 'checkbox' })}
        />
        <TextInput
          label="Inactive reason"
          description="Reason why customer is inactive"
          {...form.getInputProps('reason')}
        />
        <Button type="submit" fullWidth loading={loading}>
          Uložiť
        </Button>
      </Stack>
    </form>
  );
};
